/* eslint-disable */ export var ActivitySortBy;
(function(ActivitySortBy) {
    ActivitySortBy["Date"] = "DATE";
    ActivitySortBy["Mgmrewardspoints"] = "MGMREWARDSPOINTS";
    ActivitySortBy["Tiercredits"] = "TIERCREDITS";
})(ActivitySortBy || (ActivitySortBy = {}));
export var ActivitySortOrder;
(function(ActivitySortOrder) {
    ActivitySortOrder["Ascending"] = "ASCENDING";
    ActivitySortOrder["Descending"] = "DESCENDING";
})(ActivitySortOrder || (ActivitySortOrder = {}));
export var ActivityType;
(function(ActivityType) {
    ActivityType["Dining"] = "DINING";
    ActivityType["Freebie"] = "FREEBIE";
    ActivityType["Gaming"] = "GAMING";
    ActivityType["LoyaltyChallenge"] = "LOYALTY_CHALLENGE";
})(ActivityType || (ActivityType = {}));
export var AddressType;
(function(AddressType) {
    AddressType["Alternate"] = "ALTERNATE";
    AddressType["Billing"] = "BILLING";
    AddressType["Business"] = "BUSINESS";
    AddressType["Home"] = "HOME";
    AddressType["Other"] = "OTHER";
})(AddressType || (AddressType = {}));
export var AlertIdType;
(function(AlertIdType) {
    AlertIdType["Alias"] = "ALIAS";
    AlertIdType["Id"] = "ID";
    AlertIdType["Tinyid"] = "TINYID";
})(AlertIdType || (AlertIdType = {}));
export var AlertResponderType;
(function(AlertResponderType) {
    AlertResponderType["Escalation"] = "ESCALATION";
    AlertResponderType["Schedule"] = "SCHEDULE";
    AlertResponderType["Team"] = "TEAM";
    AlertResponderType["User"] = "USER";
})(AlertResponderType || (AlertResponderType = {}));
export var AuditEmployeeSortBy;
(function(AuditEmployeeSortBy) {
    AuditEmployeeSortBy["EmployeeNumber"] = "EMPLOYEE_NUMBER";
    AuditEmployeeSortBy["FirstName"] = "FIRST_NAME";
    AuditEmployeeSortBy["LastName"] = "LAST_NAME";
})(AuditEmployeeSortBy || (AuditEmployeeSortBy = {}));
export var AuditLogSortBy;
(function(AuditLogSortBy) {
    AuditLogSortBy["ActionType"] = "ACTION_TYPE";
    AuditLogSortBy["EmployeeName"] = "EMPLOYEE_NAME";
    AuditLogSortBy["Timestamp"] = "TIMESTAMP";
    AuditLogSortBy["ToolId"] = "TOOL_ID";
})(AuditLogSortBy || (AuditLogSortBy = {}));
export var AuditSortDirection;
(function(AuditSortDirection) {
    AuditSortDirection["Ascending"] = "ASCENDING";
    AuditSortDirection["Descending"] = "DESCENDING";
})(AuditSortDirection || (AuditSortDirection = {}));
export var AvailabilityStatus;
(function(AvailabilityStatus) {
    AvailabilityStatus["Available"] = "AVAILABLE";
    AvailabilityStatus["Noarrival"] = "NOARRIVAL";
    AvailabilityStatus["Offer"] = "OFFER";
    AvailabilityStatus["Soldout"] = "SOLDOUT";
})(AvailabilityStatus || (AvailabilityStatus = {}));
export var BiologicalSex;
(function(BiologicalSex) {
    BiologicalSex["Female"] = "FEMALE";
    BiologicalSex["Male"] = "MALE";
    BiologicalSex["Other"] = "OTHER";
    BiologicalSex["Unknown"] = "UNKNOWN";
})(BiologicalSex || (BiologicalSex = {}));
export var BookingReservationType;
(function(BookingReservationType) {
    BookingReservationType["Dining"] = "DINING";
    BookingReservationType["Room"] = "ROOM";
    BookingReservationType["Show"] = "SHOW";
})(BookingReservationType || (BookingReservationType = {}));
export var BookingWindow;
(function(BookingWindow) {
    BookingWindow["BeforeArrivalday"] = "BEFORE_ARRIVALDAY";
    BookingWindow["BeforeCheckin"] = "BEFORE_CHECKIN";
    BookingWindow["BeforeCheckout"] = "BEFORE_CHECKOUT";
})(BookingWindow || (BookingWindow = {}));
export var BookingWindowNew;
(function(BookingWindowNew) {
    BookingWindowNew["BeforeArrivalday"] = "BEFORE_ARRIVALDAY";
    BookingWindowNew["BeforeCheckin"] = "BEFORE_CHECKIN";
    BookingWindowNew["BeforeCheckout"] = "BEFORE_CHECKOUT";
})(BookingWindowNew || (BookingWindowNew = {}));
export var CartType;
(function(CartType) {
    CartType["Global"] = "GLOBAL";
    CartType["Package"] = "PACKAGE";
})(CartType || (CartType = {}));
export var CartVersion;
(function(CartVersion) {
    CartVersion["V1"] = "V1";
    CartVersion["V2"] = "V2";
})(CartVersion || (CartVersion = {}));
export var CheckoutErrorType;
(function(CheckoutErrorType) {
    CheckoutErrorType["Error"] = "ERROR";
    CheckoutErrorType["Info"] = "INFO";
    CheckoutErrorType["Warning"] = "WARNING";
})(CheckoutErrorType || (CheckoutErrorType = {}));
export var CheckoutStatus;
(function(CheckoutStatus) {
    CheckoutStatus["Failure"] = "FAILURE";
    CheckoutStatus["PaymentFailure"] = "PAYMENT_FAILURE";
    CheckoutStatus["Pending"] = "PENDING";
    CheckoutStatus["Success"] = "SUCCESS";
})(CheckoutStatus || (CheckoutStatus = {}));
export var CommunicationPreferenceType;
(function(CommunicationPreferenceType) {
    CommunicationPreferenceType["Email"] = "EMAIL";
    CommunicationPreferenceType["PushNotification"] = "PUSH_NOTIFICATION";
    CommunicationPreferenceType["Text"] = "TEXT";
})(CommunicationPreferenceType || (CommunicationPreferenceType = {}));
export var ConfirmationNumberType;
(function(ConfirmationNumberType) {
    /** This is internal id generated from cloud store */ ConfirmationNumberType["Guid"] = "GUID";
    ConfirmationNumberType["Opera"] = "OPERA";
    ConfirmationNumberType["Unknown"] = "UNKNOWN";
})(ConfirmationNumberType || (ConfirmationNumberType = {}));
export var ContactMethodsFormat;
(function(ContactMethodsFormat) {
    ContactMethodsFormat["Mobile"] = "MOBILE";
})(ContactMethodsFormat || (ContactMethodsFormat = {}));
export var ContactPreference;
(function(ContactPreference) {
    ContactPreference["Call"] = "CALL";
    ContactPreference["PushNotification"] = "PUSH_NOTIFICATION";
    ContactPreference["Text"] = "TEXT";
})(ContactPreference || (ContactPreference = {}));
export var ConventionType;
(function(ConventionType) {
    ConventionType["Convention"] = "Convention";
    ConventionType["Event"] = "Event";
})(ConventionType || (ConventionType = {}));
export var CreateTransientIdentityErrorCode;
(function(CreateTransientIdentityErrorCode) {
    CreateTransientIdentityErrorCode["AccountDisabled"] = "ACCOUNT_DISABLED";
    CreateTransientIdentityErrorCode["MultipleActiveAccounts"] = "MULTIPLE_ACTIVE_ACCOUNTS";
})(CreateTransientIdentityErrorCode || (CreateTransientIdentityErrorCode = {}));
export var CustomerDominantPlay;
(function(CustomerDominantPlay) {
    CustomerDominantPlay["Poker"] = "Poker";
    CustomerDominantPlay["Slot"] = "Slot";
    CustomerDominantPlay["Table"] = "Table";
})(CustomerDominantPlay || (CustomerDominantPlay = {}));
export var CustomerRoomOfferType;
(function(CustomerRoomOfferType) {
    CustomerRoomOfferType["Program"] = "PROGRAM";
    CustomerRoomOfferType["Segment"] = "SEGMENT";
})(CustomerRoomOfferType || (CustomerRoomOfferType = {}));
export var Day;
(function(Day) {
    Day["Friday"] = "FRIDAY";
    Day["Monday"] = "MONDAY";
    Day["Saturday"] = "SATURDAY";
    Day["Sunday"] = "SUNDAY";
    Day["Thursday"] = "THURSDAY";
    Day["Tuesday"] = "TUESDAY";
    Day["Wednesday"] = "WEDNESDAY";
})(Day || (Day = {}));
export var DeactiveReason;
(function(DeactiveReason) {
    DeactiveReason["PrivacyRtdCcpa"] = "PRIVACY_RTD_CCPA";
    DeactiveReason["PrivacyRtdCpra"] = "PRIVACY_RTD_CPRA";
    DeactiveReason["PrivacyRtdLgpd"] = "PRIVACY_RTD_LGPD";
    DeactiveReason["PrivacyRtdOther"] = "PRIVACY_RTD_OTHER";
    DeactiveReason["PrivacyRtdPipeda"] = "PRIVACY_RTD_PIPEDA";
    DeactiveReason["PrivacyRtdPpda"] = "PRIVACY_RTD_PPDA";
})(DeactiveReason || (DeactiveReason = {}));
export var DirectionType;
(function(DirectionType) {
    DirectionType["Asc"] = "ASC";
    DirectionType["Desc"] = "DESC";
})(DirectionType || (DirectionType = {}));
export var Domain;
(function(Domain) {
    Domain["Trip"] = "TRIP";
})(Domain || (Domain = {}));
export var EmailTemplateType;
(function(EmailTemplateType) {
    EmailTemplateType["Generic"] = "GENERIC";
    EmailTemplateType["Linebustercheckin"] = "LINEBUSTERCHECKIN";
    EmailTemplateType["Linebusterqrcode"] = "LINEBUSTERQRCODE";
})(EmailTemplateType || (EmailTemplateType = {}));
export var EmailType;
(function(EmailType) {
    EmailType["Business"] = "BUSINESS";
    EmailType["Other"] = "OTHER";
    EmailType["Personal"] = "PERSONAL";
})(EmailType || (EmailType = {}));
export var EventStatusType;
(function(EventStatusType) {
    EventStatusType["Registered"] = "REGISTERED";
    EventStatusType["Unregistered"] = "UNREGISTERED";
})(EventStatusType || (EventStatusType = {}));
export var ExternalIdType;
(function(ExternalIdType) {
    ExternalIdType["Archtics"] = "ARCHTICS";
    ExternalIdType["Opentable"] = "OPENTABLE";
    ExternalIdType["Opera"] = "OPERA";
    ExternalIdType["Sevenrooms"] = "SEVENROOMS";
})(ExternalIdType || (ExternalIdType = {}));
export var FilterFieldName;
(function(FilterFieldName) {
    FilterFieldName["Currencycode"] = "CURRENCYCODE";
    FilterFieldName["Hasrewardspoints"] = "HASREWARDSPOINTS";
    FilterFieldName["Hastiercredits"] = "HASTIERCREDITS";
    FilterFieldName["Lineofbusiness"] = "LINEOFBUSINESS";
    FilterFieldName["Propertyid"] = "PROPERTYID";
    FilterFieldName["Type"] = "TYPE";
})(FilterFieldName || (FilterFieldName = {}));
export var HostStatus;
(function(HostStatus) {
    HostStatus["Arrived"] = "ARRIVED";
    HostStatus["ArrivedPartial"] = "ARRIVED_PARTIAL";
    HostStatus["Autosaved"] = "AUTOSAVED";
    HostStatus["Booked"] = "BOOKED";
    HostStatus["BusTable"] = "BUS_TABLE";
    HostStatus["Canceled"] = "CANCELED";
    HostStatus["Cancelled"] = "CANCELLED";
    HostStatus["CheckDropped"] = "CHECK_DROPPED";
    HostStatus["Complete"] = "COMPLETE";
    HostStatus["Confirmed"] = "CONFIRMED";
    HostStatus["Dessert"] = "DESSERT";
    HostStatus["FirstCourse"] = "FIRST_COURSE";
    HostStatus["FourthCourse"] = "FOURTH_COURSE";
    HostStatus["Hold"] = "HOLD";
    HostStatus["Late"] = "LATE";
    HostStatus["LeftMessage"] = "LEFT_MESSAGE";
    HostStatus["NoAnswer"] = "NO_ANSWER";
    HostStatus["NoEntry"] = "NO_ENTRY";
    HostStatus["NoShow"] = "NO_SHOW";
    HostStatus["OrderPlaced"] = "ORDER_PLACED";
    HostStatus["Paid"] = "PAID";
    HostStatus["PreArrived"] = "PRE_ARRIVED";
    HostStatus["PrePartiallyArrived"] = "PRE_PARTIALLY_ARRIVED";
    HostStatus["Saved"] = "SAVED";
    HostStatus["SecondCourse"] = "SECOND_COURSE";
    HostStatus["ThirdCourse"] = "THIRD_COURSE";
    HostStatus["WrongNumber"] = "WRONG_NUMBER";
})(HostStatus || (HostStatus = {}));
export var HousekeepingReservationStatus;
(function(HousekeepingReservationStatus) {
    HousekeepingReservationStatus["Arrival"] = "ARRIVAL";
    HousekeepingReservationStatus["Arrived"] = "ARRIVED";
    HousekeepingReservationStatus["ArrivedAndStayover"] = "ARRIVED_AND_STAYOVER";
    HousekeepingReservationStatus["DayUse"] = "DAY_USE";
    HousekeepingReservationStatus["Departed"] = "DEPARTED";
    HousekeepingReservationStatus["Departures"] = "DEPARTURES";
    HousekeepingReservationStatus["DueOut"] = "DUE_OUT";
    HousekeepingReservationStatus["Expected"] = "EXPECTED";
    HousekeepingReservationStatus["NotReserved"] = "NOT_RESERVED";
    HousekeepingReservationStatus["Reserved"] = "RESERVED";
    HousekeepingReservationStatus["StayOver"] = "STAY_OVER";
    HousekeepingReservationStatus["Unknown"] = "UNKNOWN";
    HousekeepingReservationStatus["Vacant"] = "VACANT";
})(HousekeepingReservationStatus || (HousekeepingReservationStatus = {}));
export var HousekeepingStatus;
(function(HousekeepingStatus) {
    HousekeepingStatus["Occupied"] = "OCCUPIED";
    HousekeepingStatus["Vacant"] = "VACANT";
})(HousekeepingStatus || (HousekeepingStatus = {}));
export var HousekeepingStatusCode;
(function(HousekeepingStatusCode) {
    HousekeepingStatusCode["Occ"] = "OCC";
    HousekeepingStatusCode["Vac"] = "VAC";
})(HousekeepingStatusCode || (HousekeepingStatusCode = {}));
export var HyattGoldPassportTier;
(function(HyattGoldPassportTier) {
    HyattGoldPassportTier["Discoverist"] = "DISCOVERIST";
    HyattGoldPassportTier["Explorist"] = "EXPLORIST";
    HyattGoldPassportTier["Globalist"] = "GLOBALIST";
    HyattGoldPassportTier["LifetimeGlobalist"] = "LIFETIME_GLOBALIST";
    HyattGoldPassportTier["Member"] = "MEMBER";
})(HyattGoldPassportTier || (HyattGoldPassportTier = {}));
export var IdOrConfirmationType;
(function(IdOrConfirmationType) {
    IdOrConfirmationType["DiningConfirmation"] = "DINING_CONFIRMATION";
    IdOrConfirmationType["ItineraryId"] = "ITINERARY_ID";
    IdOrConfirmationType["RoomConfirmation"] = "ROOM_CONFIRMATION";
    IdOrConfirmationType["ShowConfirmation"] = "SHOW_CONFIRMATION";
})(IdOrConfirmationType || (IdOrConfirmationType = {}));
export var IdType;
(function(IdType) {
    IdType["Archtics"] = "ARCHTICS";
    IdType["Gse"] = "GSE";
    IdType["Hgp"] = "HGP";
    IdType["Id"] = "ID";
    IdType["Mgm"] = "MGM";
    IdType["Mlife"] = "MLIFE";
    IdType["Opera"] = "OPERA";
    IdType["Sevenrooms"] = "SEVENROOMS";
})(IdType || (IdType = {}));
export var IdentifierType;
(function(IdentifierType) {
    IdentifierType["Trip"] = "TRIP";
})(IdentifierType || (IdentifierType = {}));
export var IdentifierTypes;
(function(IdentifierTypes) {
    IdentifierTypes["AnalyticsId"] = "ANALYTICS_ID";
    IdentifierTypes["CardId"] = "CARD_ID";
    IdentifierTypes["CdpId"] = "CDP_ID";
    IdentifierTypes["DiningProfileId"] = "DINING_PROFILE_ID";
    IdentifierTypes["GamingId"] = "GAMING_ID";
    IdentifierTypes["GseId"] = "GSE_ID";
    IdentifierTypes["LoyaltyId"] = "LOYALTY_ID";
    IdentifierTypes["MgmId"] = "MGM_ID";
    IdentifierTypes["MlifeNumber"] = "MLIFE_NUMBER";
    IdentifierTypes["PreferenceCenterId"] = "PREFERENCE_CENTER_ID";
    IdentifierTypes["RoomsProfileId"] = "ROOMS_PROFILE_ID";
    IdentifierTypes["ShowsProfileId"] = "SHOWS_PROFILE_ID";
})(IdentifierTypes || (IdentifierTypes = {}));
export var IdentityDocumentImageType;
(function(IdentityDocumentImageType) {
    IdentityDocumentImageType["Back"] = "BACK";
    IdentityDocumentImageType["Front"] = "FRONT";
    IdentityDocumentImageType["Profile"] = "PROFILE";
    IdentityDocumentImageType["Unknown"] = "UNKNOWN";
})(IdentityDocumentImageType || (IdentityDocumentImageType = {}));
export var IdentityDocumentTypes;
(function(IdentityDocumentTypes) {
    IdentityDocumentTypes["DriversLicense"] = "DRIVERS_LICENSE";
    IdentityDocumentTypes["NationalId"] = "NATIONAL_ID";
    IdentityDocumentTypes["Other"] = "OTHER";
    IdentityDocumentTypes["PassportBook"] = "PASSPORT_BOOK";
    IdentityDocumentTypes["PassportCard"] = "PASSPORT_CARD";
    IdentityDocumentTypes["StateId"] = "STATE_ID";
})(IdentityDocumentTypes || (IdentityDocumentTypes = {}));
export var IdentityStatus;
(function(IdentityStatus) {
    IdentityStatus["Active"] = "ACTIVE";
    IdentityStatus["Deactivated"] = "DEACTIVATED";
    IdentityStatus["PendingUserAction"] = "PENDING_USER_ACTION";
    IdentityStatus["Provisioned"] = "PROVISIONED";
    IdentityStatus["Staged"] = "STAGED";
    IdentityStatus["Suspended"] = "SUSPENDED";
})(IdentityStatus || (IdentityStatus = {}));
export var InterestCode;
(function(InterestCode) {
    InterestCode["Hotelautoec"] = "HOTELAUTOEC";
    InterestCode["Matchplay"] = "MATCHPLAY";
    InterestCode["Slotdollar"] = "SLOTDOLLAR";
})(InterestCode || (InterestCode = {}));
export var ItemOfferType;
(function(ItemOfferType) {
    ItemOfferType["MyVegas"] = "MY_VEGAS";
    ItemOfferType["Other"] = "OTHER";
    ItemOfferType["Package"] = "PACKAGE";
    ItemOfferType["PatronPromo"] = "PATRON_PROMO";
    ItemOfferType["PerpetualOffer"] = "PERPETUAL_OFFER";
    ItemOfferType["Promo"] = "PROMO";
})(ItemOfferType || (ItemOfferType = {}));
export var ItemStatus;
(function(ItemStatus) {
    ItemStatus["DatesExpired"] = "DATES_EXPIRED";
    ItemStatus["Failed"] = "FAILED";
    ItemStatus["Invalid"] = "INVALID";
    ItemStatus["InventoryUnavailable"] = "INVENTORY_UNAVAILABLE";
    ItemStatus["ItemExpired"] = "ITEM_EXPIRED";
    ItemStatus["PriceExpired"] = "PRICE_EXPIRED";
    ItemStatus["Saved"] = "SAVED";
    ItemStatus["Success"] = "SUCCESS";
})(ItemStatus || (ItemStatus = {}));
export var ItemType;
(function(ItemType) {
    ItemType["ComponentCharge"] = "ComponentCharge";
    ItemType["ComponentChargeTax"] = "ComponentChargeTax";
    ItemType["ExtraGuestCharge"] = "ExtraGuestCharge";
    ItemType["ExtraGuestChargeTax"] = "ExtraGuestChargeTax";
    ItemType["ResortFee"] = "ResortFee";
    ItemType["ResortFeeTax"] = "ResortFeeTax";
    ItemType["RoomCharge"] = "RoomCharge";
    ItemType["RoomChargeTax"] = "RoomChargeTax";
})(ItemType || (ItemType = {}));
export var ItemsToRemove;
(function(ItemsToRemove) {
    ItemsToRemove["All"] = "ALL";
    ItemsToRemove["CheckoutIneligibleItemsOnly"] = "CHECKOUT_INELIGIBLE_ITEMS_ONLY";
    ItemsToRemove["JwbItemsOnly"] = "JWB_ITEMS_ONLY";
})(ItemsToRemove || (ItemsToRemove = {}));
export var MhebLoginState;
(function(MhebLoginState) {
    MhebLoginState["Default"] = "DEFAULT";
    MhebLoginState["MgmRewards"] = "MGM_REWARDS";
    MhebLoginState["Transient"] = "TRANSIENT";
    MhebLoginState["Unauthenticated"] = "UNAUTHENTICATED";
})(MhebLoginState || (MhebLoginState = {}));
export var MhebNetworkState;
(function(MhebNetworkState) {
    MhebNetworkState["Default"] = "DEFAULT";
    MhebNetworkState["Offline"] = "OFFLINE";
    MhebNetworkState["Online"] = "ONLINE";
})(MhebNetworkState || (MhebNetworkState = {}));
export var MhebTripState;
(function(MhebTripState) {
    MhebTripState["Default"] = "DEFAULT";
    MhebTripState["ImminentTrip"] = "IMMINENT_TRIP";
    MhebTripState["InTrip"] = "IN_TRIP";
    MhebTripState["NoTrip"] = "NO_TRIP";
    MhebTripState["PostTrip"] = "POST_TRIP";
    MhebTripState["PreTrip_72PlusHours"] = "PRE_TRIP_72_PLUS_HOURS";
    MhebTripState["PreTripLess_72Hours"] = "PRE_TRIP_LESS_72_HOURS";
    MhebTripState["PreTripPaymentAdded"] = "PRE_TRIP_PAYMENT_ADDED";
})(MhebTripState || (MhebTripState = {}));
export var MLifeTier;
(function(MLifeTier) {
    MLifeTier["Gold"] = "GOLD";
    MLifeTier["Noir"] = "NOIR";
    MLifeTier["Pearl"] = "PEARL";
    MLifeTier["Platinum"] = "PLATINUM";
    MLifeTier["Sapphire"] = "SAPPHIRE";
    MLifeTier["Unknown"] = "UNKNOWN";
})(MLifeTier || (MLifeTier = {}));
export var MarketCodeType;
(function(MarketCodeType) {
    MarketCodeType["Casino"] = "CASINO";
    MarketCodeType["Convention"] = "CONVENTION";
    MarketCodeType["Leisure"] = "LEISURE";
    MarketCodeType["Transient"] = "TRANSIENT";
})(MarketCodeType || (MarketCodeType = {}));
export var MyVegasRewardType;
(function(MyVegasRewardType) {
    MyVegasRewardType["Rooms"] = "Rooms";
    MyVegasRewardType["Shows"] = "Shows";
})(MyVegasRewardType || (MyVegasRewardType = {}));
export var OfferType;
(function(OfferType) {
    OfferType["Program"] = "Program";
    OfferType["Segment"] = "Segment";
})(OfferType || (OfferType = {}));
export var OffersProductType;
(function(OffersProductType) {
    OffersProductType["All"] = "ALL";
    OffersProductType["Entertainment"] = "ENTERTAINMENT";
    OffersProductType["Hotel"] = "HOTEL";
    OffersProductType["Other"] = "OTHER";
})(OffersProductType || (OffersProductType = {}));
export var OperaProfileAddressType;
(function(OperaProfileAddressType) {
    OperaProfileAddressType["Alternate"] = "ALTERNATE";
    OperaProfileAddressType["Business"] = "BUSINESS";
    OperaProfileAddressType["Home"] = "HOME";
    OperaProfileAddressType["Other"] = "OTHER";
})(OperaProfileAddressType || (OperaProfileAddressType = {}));
export var OperaProfileGuestTitle;
(function(OperaProfileGuestTitle) {
    OperaProfileGuestTitle["Mr"] = "MR";
    OperaProfileGuestTitle["Mrs"] = "MRS";
    OperaProfileGuestTitle["Ms"] = "MS";
})(OperaProfileGuestTitle || (OperaProfileGuestTitle = {}));
export var OperaProfilePhoneType;
(function(OperaProfilePhoneType) {
    OperaProfilePhoneType["Business"] = "BUSINESS";
    OperaProfilePhoneType["Fax"] = "FAX";
    OperaProfilePhoneType["Home"] = "HOME";
    OperaProfilePhoneType["Mobile"] = "MOBILE";
    OperaProfilePhoneType["Other"] = "OTHER";
    OperaProfilePhoneType["Pager"] = "PAGER";
})(OperaProfilePhoneType || (OperaProfilePhoneType = {}));
export var OperaState;
(function(OperaState) {
    OperaState["Canceled"] = "CANCELED";
    OperaState["Checkedout"] = "CHECKEDOUT";
    OperaState["Inhouse"] = "INHOUSE";
    OperaState["Legcanceled"] = "LEGCANCELED";
    OperaState["Noshow"] = "NOSHOW";
    OperaState["Prospect"] = "PROSPECT";
    OperaState["Requestdenied"] = "REQUESTDENIED";
    OperaState["Requested"] = "REQUESTED";
    OperaState["Reserved"] = "RESERVED";
    OperaState["Waitlisted"] = "WAITLISTED";
    OperaState["Waitlisttoactive"] = "WAITLISTTOACTIVE";
})(OperaState || (OperaState = {}));
export var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Failure"] = "FAILURE";
    OrderStatus["Partial"] = "PARTIAL";
    OrderStatus["PaymentFailure"] = "PAYMENT_FAILURE";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Success"] = "SUCCESS";
})(OrderStatus || (OrderStatus = {}));
export var PackageType;
(function(PackageType) {
    PackageType["Other"] = "OTHER";
    PackageType["ShowAndRoom"] = "SHOW_AND_ROOM";
})(PackageType || (PackageType = {}));
export var Partner;
(function(Partner) {
    Partner["Marriott"] = "MARRIOTT";
})(Partner || (Partner = {}));
export var PhoneNumberType;
(function(PhoneNumberType) {
    PhoneNumberType["Business"] = "Business";
    PhoneNumberType["Fax"] = "Fax";
    PhoneNumberType["Home"] = "Home";
    PhoneNumberType["Mobile"] = "Mobile";
    PhoneNumberType["Other"] = "Other";
    PhoneNumberType["Pager"] = "Pager";
})(PhoneNumberType || (PhoneNumberType = {}));
export var PhoneType;
(function(PhoneType) {
    PhoneType["Business"] = "BUSINESS";
    PhoneType["Fax"] = "FAX";
    PhoneType["Home"] = "HOME";
    PhoneType["Mobile"] = "MOBILE";
    PhoneType["Other"] = "OTHER";
})(PhoneType || (PhoneType = {}));
export var PreferenceContext;
(function(PreferenceContext) {
    PreferenceContext["Marketing"] = "MARKETING";
    PreferenceContext["Transaction"] = "TRANSACTION";
})(PreferenceContext || (PreferenceContext = {}));
export var PreferenceType;
(function(PreferenceType) {
    PreferenceType["Dining"] = "DINING";
    PreferenceType["Freebie"] = "FREEBIE";
    PreferenceType["Gaming"] = "GAMING";
    PreferenceType["LoyaltyChallenge"] = "LOYALTY_CHALLENGE";
    PreferenceType["Room"] = "ROOM";
    PreferenceType["Show"] = "SHOW";
})(PreferenceType || (PreferenceType = {}));
export var PricingMode;
(function(PricingMode) {
    PricingMode["BestAvailable"] = "BEST_AVAILABLE";
    PricingMode["Perpetual"] = "PERPETUAL";
    PricingMode["Program"] = "PROGRAM";
})(PricingMode || (PricingMode = {}));
export var PricingType;
(function(PricingType) {
    PricingType["PerNight"] = "PER_NIGHT";
    PricingType["PerStay"] = "PER_STAY";
})(PricingType || (PricingType = {}));
export var ProductType;
(function(ProductType) {
    ProductType["Air"] = "AIR";
    ProductType["Dining"] = "DINING";
    ProductType["Limo"] = "LIMO";
    ProductType["Other"] = "OTHER";
    ProductType["Room"] = "ROOM";
    ProductType["Show"] = "SHOW";
    ProductType["Table"] = "TABLE";
})(ProductType || (ProductType = {}));
export var ProfileAddressType;
(function(ProfileAddressType) {
    ProfileAddressType["Alternate"] = "Alternate";
    ProfileAddressType["Business"] = "Business";
    ProfileAddressType["Home"] = "Home";
    ProfileAddressType["Other"] = "Other";
})(ProfileAddressType || (ProfileAddressType = {}));
export var ProfileType;
(function(ProfileType) {
    ProfileType["Opentable"] = "OPENTABLE";
    ProfileType["Opera"] = "OPERA";
    ProfileType["Patron"] = "PATRON";
    ProfileType["Sevenrooms"] = "SEVENROOMS";
    ProfileType["Ticketmaster"] = "TICKETMASTER";
})(ProfileType || (ProfileType = {}));
export var ProfileTypeFilter;
(function(ProfileTypeFilter) {
    ProfileTypeFilter["Group"] = "GROUP";
    ProfileTypeFilter["Guest"] = "GUEST";
    ProfileTypeFilter["Wholesaler"] = "WHOLESALER";
})(ProfileTypeFilter || (ProfileTypeFilter = {}));
export var QueryType;
(function(QueryType) {
    QueryType["All"] = "ALL";
    QueryType["Future"] = "FUTURE";
    QueryType["Past"] = "PAST";
})(QueryType || (QueryType = {}));
export var ReservationState;
(function(ReservationState) {
    ReservationState["Autosaved"] = "AUTOSAVED";
    ReservationState["Booked"] = "BOOKED";
    ReservationState["Cancelled"] = "CANCELLED";
    ReservationState["Saved"] = "SAVED";
})(ReservationState || (ReservationState = {}));
export var ReservationStatus;
(function(ReservationStatus) {
    ReservationStatus["Canceled"] = "CANCELED";
    ReservationStatus["Checkedout"] = "CHECKEDOUT";
    ReservationStatus["Inhouse"] = "INHOUSE";
    ReservationStatus["Noshow"] = "NOSHOW";
    ReservationStatus["Reserved"] = "RESERVED";
})(ReservationStatus || (ReservationStatus = {}));
export var ReservationType;
(function(ReservationType) {
    ReservationType["Default"] = "DEFAULT";
    ReservationType["Dining"] = "DINING";
    ReservationType["Freebie"] = "FREEBIE";
    ReservationType["Room"] = "ROOM";
    ReservationType["Show"] = "SHOW";
})(ReservationType || (ReservationType = {}));
export var ResetPasswordMethod;
(function(ResetPasswordMethod) {
    ResetPasswordMethod["Email"] = "EMAIL";
})(ResetPasswordMethod || (ResetPasswordMethod = {}));
export var RewardType;
(function(RewardType) {
    RewardType["Challenge"] = "CHALLENGE";
    RewardType["Goal"] = "GOAL";
})(RewardType || (RewardType = {}));
export var RoomComponentPricingApplied;
(function(RoomComponentPricingApplied) {
    RoomComponentPricingApplied["Checkin"] = "CHECKIN";
    RoomComponentPricingApplied["Checkout"] = "CHECKOUT";
    RoomComponentPricingApplied["Nightly"] = "NIGHTLY";
    RoomComponentPricingApplied["None"] = "NONE";
    RoomComponentPricingApplied["Perstay"] = "PERSTAY";
})(RoomComponentPricingApplied || (RoomComponentPricingApplied = {}));
export var RoomReservationAddOnPurchaseStatus;
(function(RoomReservationAddOnPurchaseStatus) {
    RoomReservationAddOnPurchaseStatus["Available"] = "AVAILABLE";
    RoomReservationAddOnPurchaseStatus["Purchased"] = "PURCHASED";
    RoomReservationAddOnPurchaseStatus["PurchasedExternal"] = "PURCHASED_EXTERNAL";
    RoomReservationAddOnPurchaseStatus["PurchasedRestricted"] = "PURCHASED_RESTRICTED";
    RoomReservationAddOnPurchaseStatus["Restricted"] = "RESTRICTED";
    RoomReservationAddOnPurchaseStatus["Soldout"] = "SOLDOUT";
})(RoomReservationAddOnPurchaseStatus || (RoomReservationAddOnPurchaseStatus = {}));
export var RoomReservationAddOnStatus;
(function(RoomReservationAddOnStatus) {
    RoomReservationAddOnStatus["Available"] = "AVAILABLE";
    RoomReservationAddOnStatus["Purchased"] = "PURCHASED";
    RoomReservationAddOnStatus["Soldout"] = "SOLDOUT";
})(RoomReservationAddOnStatus || (RoomReservationAddOnStatus = {}));
export var RoomReservationNameMatchType;
(function(RoomReservationNameMatchType) {
    RoomReservationNameMatchType["Full"] = "FULL";
    RoomReservationNameMatchType["Like"] = "LIKE";
})(RoomReservationNameMatchType || (RoomReservationNameMatchType = {}));
export var RoomReservationNameSearchOperation;
(function(RoomReservationNameSearchOperation) {
    RoomReservationNameSearchOperation["Full"] = "FULL";
    RoomReservationNameSearchOperation["Startswith"] = "STARTSWITH";
})(RoomReservationNameSearchOperation || (RoomReservationNameSearchOperation = {}));
export var RoomReservationState;
(function(RoomReservationState) {
    RoomReservationState["Booked"] = "Booked";
    RoomReservationState["Cancelled"] = "Cancelled";
    RoomReservationState["Saved"] = "Saved";
})(RoomReservationState || (RoomReservationState = {}));
export var RoomStatus;
(function(RoomStatus) {
    RoomStatus["Clean"] = "CLEAN";
    RoomStatus["Dirty"] = "DIRTY";
    RoomStatus["Inspected"] = "INSPECTED";
    RoomStatus["OutOfOrder"] = "OUT_OF_ORDER";
    RoomStatus["OutOfService"] = "OUT_OF_SERVICE";
    RoomStatus["Pickup"] = "PICKUP";
})(RoomStatus || (RoomStatus = {}));
export var RoomStatusCode;
(function(RoomStatusCode) {
    RoomStatusCode["Cl"] = "CL";
    RoomStatusCode["Di"] = "DI";
    RoomStatusCode["Ip"] = "IP";
    RoomStatusCode["Oo"] = "OO";
    RoomStatusCode["Os"] = "OS";
    RoomStatusCode["Pu"] = "PU";
})(RoomStatusCode || (RoomStatusCode = {}));
export var RoomUpsellStatus;
(function(RoomUpsellStatus) {
    /** When a customer has purchased an upsell and it has been awarded. */ RoomUpsellStatus["Awarded"] = "AWARDED";
    /** When a customer has committed to an upsell but the upsell has not been awarded or denied yet. */ RoomUpsellStatus["Committed"] = "COMMITTED";
    /** When a customer has purchased an upsell and it has been denied. */ RoomUpsellStatus["Denied"] = "DENIED";
})(RoomUpsellStatus || (RoomUpsellStatus = {}));
export var RoomUpsellType;
(function(RoomUpsellType) {
    /** Upsells that occur during check in process. These are granted automatically and do not require manual approval/denial. */ RoomUpsellType["Confirmed"] = "CONFIRMED";
    /** Upsells that are done prior to arrival that are not guaranteed. These will be manually approved or denied. */ RoomUpsellType["Standby"] = "STANDBY";
})(RoomUpsellType || (RoomUpsellType = {}));
export var SearchContentType;
(function(SearchContentType) {
    SearchContentType["Amenities"] = "AMENITIES";
    SearchContentType["Article"] = "ARTICLE";
    SearchContentType["Casino"] = "CASINO";
    SearchContentType["Entertainment"] = "ENTERTAINMENT";
    SearchContentType["Faq"] = "FAQ";
    SearchContentType["Hour_24"] = "HOUR_24";
    SearchContentType["MeetingGroup"] = "MEETING_GROUP";
    SearchContentType["Mgmrewards"] = "MGMREWARDS";
    SearchContentType["Moments"] = "MOMENTS";
    SearchContentType["Nightlife"] = "NIGHTLIFE";
    SearchContentType["Offer"] = "OFFER";
    SearchContentType["Restaurant"] = "RESTAURANT";
    SearchContentType["Room"] = "ROOM";
    SearchContentType["Segments"] = "SEGMENTS";
    SearchContentType["Unknown"] = "UNKNOWN";
})(SearchContentType || (SearchContentType = {}));
export var ServiceGraphServiceCdType;
(function(ServiceGraphServiceCdType) {
    ServiceGraphServiceCdType["AzureDevOps"] = "AZURE_DEV_OPS";
    ServiceGraphServiceCdType["CircleCi"] = "CIRCLE_CI";
    ServiceGraphServiceCdType["GithubActions"] = "GITHUB_ACTIONS";
    ServiceGraphServiceCdType["Other"] = "OTHER";
})(ServiceGraphServiceCdType || (ServiceGraphServiceCdType = {}));
export var ServiceGraphServiceFunctionalType;
(function(ServiceGraphServiceFunctionalType) {
    ServiceGraphServiceFunctionalType["BatchProcessing"] = "BATCH_PROCESSING";
    ServiceGraphServiceFunctionalType["CustomerFacing"] = "CUSTOMER_FACING";
    ServiceGraphServiceFunctionalType["DeveloperTool"] = "DEVELOPER_TOOL";
    ServiceGraphServiceFunctionalType["EmployeeTool"] = "EMPLOYEE_TOOL";
    ServiceGraphServiceFunctionalType["EventStream"] = "EVENT_STREAM";
    ServiceGraphServiceFunctionalType["Monitoring"] = "MONITORING";
    ServiceGraphServiceFunctionalType["Other"] = "OTHER";
})(ServiceGraphServiceFunctionalType || (ServiceGraphServiceFunctionalType = {}));
export var ServiceGraphServiceHostingCloudType;
(function(ServiceGraphServiceHostingCloudType) {
    ServiceGraphServiceHostingCloudType["Aws"] = "AWS";
    ServiceGraphServiceHostingCloudType["Azure"] = "AZURE";
    ServiceGraphServiceHostingCloudType["OnPrem"] = "ON_PREM";
    ServiceGraphServiceHostingCloudType["Other"] = "OTHER";
})(ServiceGraphServiceHostingCloudType || (ServiceGraphServiceHostingCloudType = {}));
export var ServiceGraphServiceHostingType;
(function(ServiceGraphServiceHostingType) {
    ServiceGraphServiceHostingType["AwsEc2"] = "AWS_EC2";
    ServiceGraphServiceHostingType["AwsEcr"] = "AWS_ECR";
    ServiceGraphServiceHostingType["AwsLambda"] = "AWS_LAMBDA";
    ServiceGraphServiceHostingType["AwsLightsail"] = "AWS_LIGHTSAIL";
    ServiceGraphServiceHostingType["AzureFunction"] = "AZURE_FUNCTION";
    ServiceGraphServiceHostingType["AzureWebApp"] = "AZURE_WEB_APP";
    ServiceGraphServiceHostingType["OnPrem"] = "ON_PREM";
    ServiceGraphServiceHostingType["Other"] = "OTHER";
})(ServiceGraphServiceHostingType || (ServiceGraphServiceHostingType = {}));
export var ServiceGraphServiceStatusDisasterRecoveryStage;
(function(ServiceGraphServiceStatusDisasterRecoveryStage) {
    ServiceGraphServiceStatusDisasterRecoveryStage["Stage1"] = "STAGE1";
    ServiceGraphServiceStatusDisasterRecoveryStage["Stage2"] = "STAGE2";
    ServiceGraphServiceStatusDisasterRecoveryStage["Stage3"] = "STAGE3";
    ServiceGraphServiceStatusDisasterRecoveryStage["Stage4"] = "STAGE4";
    ServiceGraphServiceStatusDisasterRecoveryStage["Stage5"] = "STAGE5";
    ServiceGraphServiceStatusDisasterRecoveryStage["Undefined"] = "UNDEFINED";
})(ServiceGraphServiceStatusDisasterRecoveryStage || (ServiceGraphServiceStatusDisasterRecoveryStage = {}));
export var ServiceGraphServiceStatusLifeStage;
(function(ServiceGraphServiceStatusLifeStage) {
    ServiceGraphServiceStatusLifeStage["Decommissioned"] = "DECOMMISSIONED";
    ServiceGraphServiceStatusLifeStage["Deprecated"] = "DEPRECATED";
    ServiceGraphServiceStatusLifeStage["Development"] = "DEVELOPMENT";
    ServiceGraphServiceStatusLifeStage["Other"] = "OTHER";
    ServiceGraphServiceStatusLifeStage["Production"] = "PRODUCTION";
})(ServiceGraphServiceStatusLifeStage || (ServiceGraphServiceStatusLifeStage = {}));
export var SetPreferenceState;
(function(SetPreferenceState) {
    SetPreferenceState["Off"] = "OFF";
    SetPreferenceState["On"] = "ON";
})(SetPreferenceState || (SetPreferenceState = {}));
export var ShareType;
(function(ShareType) {
    ShareType["DigitalKey"] = "DIGITAL_KEY";
    ShareType["PrimaryCc"] = "PRIMARY_CC";
    ShareType["SecondaryCc"] = "SECONDARY_CC";
})(ShareType || (ShareType = {}));
export var ShareWithType;
(function(ShareWithType) {
    ShareWithType["Entire"] = "Entire";
    ShareWithType["Full"] = "Full";
    ShareWithType["Split"] = "Split";
})(ShareWithType || (ShareWithType = {}));
export var ShoppingFlow;
(function(ShoppingFlow) {
    ShoppingFlow["Perpetual"] = "PERPETUAL";
    ShoppingFlow["RatePlans"] = "RATE_PLANS";
})(ShoppingFlow || (ShoppingFlow = {}));
export var ShowTicketState;
(function(ShowTicketState) {
    ShowTicketState["Booked"] = "BOOKED";
    ShowTicketState["Held"] = "HELD";
    ShowTicketState["Saved"] = "SAVED";
})(ShowTicketState || (ShowTicketState = {}));
export var SiteNameType;
(function(SiteNameType) {
    SiteNameType["Aria"] = "ARIA";
    SiteNameType["BeauRivage"] = "BeauRivage";
    SiteNameType["Bellagio"] = "Bellagio";
    SiteNameType["BetMgm"] = "BetMGM";
    SiteNameType["Borgata"] = "Borgata";
    SiteNameType["BorgataPreConversion"] = "BorgataPreConversion";
    SiteNameType["CircusCircusLasVegas"] = "CircusCircusLasVegas";
    SiteNameType["EmpireCityCasino"] = "EmpireCityCasino";
    SiteNameType["Excalibur"] = "Excalibur";
    SiteNameType["GoldStrike"] = "GoldStrike";
    SiteNameType["Luxor"] = "Luxor";
    SiteNameType["MgmDetroit"] = "MGMDetroit";
    SiteNameType["MgmGrand"] = "MGMGrand";
    SiteNameType["MgmNorthfieldPark"] = "MGMNorthfieldPark";
    SiteNameType["MandalayBay"] = "MandalayBay";
    SiteNameType["Mirage"] = "Mirage";
    SiteNameType["NationalHarbor"] = "NationalHarbor";
    SiteNameType["NewYorkNewYork"] = "NewYorkNewYork";
    SiteNameType["ParkMgm"] = "ParkMGM";
    SiteNameType["Springfield"] = "Springfield";
    SiteNameType["TheCosmopolitan"] = "TheCosmopolitan";
    SiteNameType["TreasureIsland"] = "TreasureIsland";
    SiteNameType["Unknown"] = "Unknown";
    SiteNameType["Vdara"] = "Vdara";
})(SiteNameType || (SiteNameType = {}));
export var SmartQueueStorageType;
(function(SmartQueueStorageType) {
    SmartQueueStorageType["Checkin"] = "CHECKIN";
    SmartQueueStorageType["Staging"] = "STAGING";
})(SmartQueueStorageType || (SmartQueueStorageType = {}));
export var SourceSystemType;
(function(SourceSystemType) {
    SourceSystemType["Archtics"] = "ARCHTICS";
    SourceSystemType["Opera"] = "OPERA";
    SourceSystemType["SevenRooms"] = "SEVEN_ROOMS";
})(SourceSystemType || (SourceSystemType = {}));
export var State;
(function(State) {
    State["Autosaved"] = "Autosaved";
    State["Booked"] = "Booked";
    State["Cancelled"] = "Cancelled";
    State["Saved"] = "Saved";
})(State || (State = {}));
export var StreakStatus;
(function(StreakStatus) {
    StreakStatus["Active"] = "ACTIVE";
    StreakStatus["Cancelled"] = "CANCELLED";
    StreakStatus["Complete"] = "COMPLETE";
    StreakStatus["Expired"] = "EXPIRED";
})(StreakStatus || (StreakStatus = {}));
export var StringFormatType;
(function(StringFormatType) {
    StringFormatType["SentenceCase"] = "SENTENCE_CASE";
    StringFormatType["TitleCase"] = "TITLE_CASE";
})(StringFormatType || (StringFormatType = {}));
export var TierException;
(function(TierException) {
    TierException["None"] = "NONE";
    TierException["NoEc"] = "NO_EC";
})(TierException || (TierException = {}));
export var TripType;
(function(TripType) {
    TripType["Mgm"] = "MGM";
    TripType["Mlife"] = "MLIFE";
    TripType["Profile"] = "PROFILE";
    TripType["Share"] = "SHARE";
    TripType["Trip"] = "TRIP";
})(TripType || (TripType = {}));
export const FeatureFlagsQueryDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "FeatureFlagsQuery"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "contextKind"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "userKey"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "attributes"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "FeatureFlagVariationsAttributes"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "featureFlagVariationDetails"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "contextKind"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "contextKind"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "userKey"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userKey"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "attributes"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "attributes"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "flagKey"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "flagValue"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userKey"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
